export class PrizeThresholdConstants {
    static type1 = 250
    static type2 = 375
    static type3 = 500
}